var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticStyle:{"padding":"20px"}},[_vm._v("403!您没有访问该页面的权限！请联系管理员。")])
}
var staticRenderFns = []

export { render, staticRenderFns }